import React from 'react';

export const ThemeContext = React.createContext();

export const ThemeProvider = ({children}) => {
    const [theme, setTheme] = React.useState('light');

    // Detect system theme preference on component mount
    React.useEffect(() => {
        // Function to check if device is mobile
        const isMobile = () => {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        };

        // Check if the user prefers dark mode
        const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        
        // Set initial theme based on system preference
        const setInitialTheme = () => {
            // For mobile devices, double check the theme preference
            if (isMobile()) {
                // Some mobile browsers also support matchMedia
                if (darkModeMediaQuery.matches || 
                    window.navigator.userAgent.includes('AndroidDarkMode') ||
                    (window.navigator.userAgent.includes('iPhone') && window.navigator.userAgent.includes('DarkMode'))) {
                    setTheme('dark');
                } else {
                    setTheme('light');
                }
            } else {
                // For desktop devices
                setTheme(darkModeMediaQuery.matches ? 'dark' : 'light');
            }
        };

        setInitialTheme();

        // Listen for changes in system theme preference
        const handleThemeChange = (e) => {
            setTheme(e.matches ? 'dark' : 'light');
        };

        darkModeMediaQuery.addEventListener('change', handleThemeChange);

        // Cleanup listener on component unmount
        return () => {
            darkModeMediaQuery.removeEventListener('change', handleThemeChange);
        };
    }, []);

    const ToggleTheme = () => {
        setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
    };

    return (
        <ThemeContext.Provider value={{theme, ToggleTheme}}>
            {children}
        </ThemeContext.Provider>
    );
}
